import { type ComponentType } from 'react';
import {
    type BaseFields,
    type BaseFormActions,
    type BaseValidationError,
    type FormDeclaration,
} from '@adv-frontend/form-kit';
import { useFormIsInitialized } from './hooks/useFormIsInitialized';

/*
 * HOC для отрисовки компонента находящегося за пределами формы только после инициализации формы
 * @param form
 * @param getFormId
 * @param Component
 * @param Fallback
 */
export function withFormInitializedCheckHoc<
    Props extends object,
    FormName extends string,
    FormFields extends BaseFields,
    FormValidationError extends BaseValidationError,
    FormContextInput,
    FormActions extends BaseFormActions,
    FormContext,
    FormSubmitArg,
    FormSubmitReturnValue,
>(
    form: FormDeclaration<
        FormName,
        FormFields,
        FormValidationError,
        FormContextInput,
        FormContext,
        FormActions,
        FormSubmitArg,
        FormSubmitReturnValue
    >,
    getFormId: (props: Props) => string,
    Component: ComponentType<Props>,
    Fallback: ComponentType<Props>
) {
    return function WithFormInitialized(props: Props) {
        const isInitialized = useFormIsInitialized(form, getFormId(props));

        if (!isInitialized) {
            return <Fallback {...props} />;
        }

        return <Component {...props} />;
    };
}
